import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import AOS from "aos";

import "./Aircraft.scss";
import aircraftHistory from "./AircraftHistoryData";

export default function AircraftHistory() {
  const [aircraft, setAircraft] = useState([]);

  useEffect(() => {
    setAircraft(aircraftHistory.sort((a, b) => b.year - a.year));
    AOS.init({
      easing: "ease",
    });
  }, []);

  const renderSpecs = (specs) => {
    const specItems = [
      { label: "Config", value: specs.config },
      { label: "Wingspan", value: specs.wingspan, unit: "ft" },
      { label: "Fuselage Length", value: specs.fuselageLength, unit: "ft" },
      { label: "Empty Weight", value: specs.emptyWeight, unit: "lbs" },
      { label: "MTOW", value: specs.mtow, unit: "lbs" },
      { label: "Payload", value: specs.payload, unit: "lbs" },
      { label: "Static Thrust", value: specs.staticThrust, unit: "lbs" },
      { label: "TO Distance", value: specs.toDistance, unit: "ft" },
    ];

    return (
      <div className="timeline-specs">
        {specItems.map((item, idx) => {
          if (item.value === null || item.value === undefined) return null;
          return (
            <div key={idx} className="spec-item">
              <span className="spec-label">{item.label}:</span>
              <span className="spec-value">
                {item.value}
                {item.unit && ` ${item.unit}`}
              </span>
            </div>
          );
        })}
      </div>
    );
  };

  const renderLinks = (aircraft) => {
    const links = [
      { label: "CDR", url: aircraft.cdrSlides },
      { label: "Report", url: aircraft.report },
      { label: "Flight Videos", url: aircraft.flightVideos },
      { label: "Results", url: aircraft.compResults, isText: true },
    ];

    return (
      <div className="timeline-links">
        {links.map((link, idx) => {
          if (!link.url) return null;
          if (link.isText) {
            return (
              <span key={idx} className="link-item text-link">
                {link.label}: {link.url}
              </span>
            );
          }
          return (
            <a
              key={idx}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="link-item"
            >
              {link.label}
            </a>
          );
        })}
      </div>
    );
  };

  return (
    <>
      <Helmet>
        <title>Aircraft History | M-Fly</title>
      </Helmet>
      <div className="Aircraft">
        <div className="white-div">
          <div className="aircraft-history">
            <h1>Aircraft History</h1>
            <p>
              From early prototypes to competition-ready designs, M-Fly has
              continuously evolved its aircraft to meet new performance goals,
              mission profiles, and competition rules. This timeline highlights
              notable past airframes, milestones, and the evolution of our
              designs.
            </p>
          </div>
        </div>

        <div className="timeline-container">
          {aircraft.map((airframe, index) => (
            <div
              key={index}
              className={`timeline-event ${index % 2 === 0 ? "timeline-left" : "timeline-right"}`}
              data-aos="fade-up"
              data-aos-duration="800"
            >
              <div className="timeline-marker">
                <div className="timeline-dot"></div>
              </div>
              <div className="timeline-content">
                <div className="timeline-card">
                  <div className="timeline-top">
                    {airframe.picture && (
                      <div className="timeline-image">
                        <img src={airframe.picture} alt={airframe.name} />
                      </div>
                    )}
                    <div className="timeline-card-content">
                      <div className="timeline-header">
                        <h2 className="aircraft-name">{airframe.name}</h2>
                        <span className="timeline-year">{airframe.year}</span>
                      </div>
                      <div className="timeline-meta">
                        <span className="meta-item subteam-badge">
                          {airframe.subteam}
                        </span>
                      </div>
                    </div>
                  </div>

                  {renderSpecs(airframe)}

                  {renderLinks(airframe)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
